import { MenuItem } from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import Select from "@mui/material/Select";
import {
  StyledHelperText,
  StyledInputLabel,
  StyledSelect,
} from "./StyledSelect";

function SelectField({
  label,
  options,
  value,
  onChange,
  placeholder,
  error,
  helperText,
  disabled,
  onBlur,
  required,
  id
}) {
  const renderOptions = () => {
    if (options) {
      return options.map((val, idx) => (
        <MenuItem key={idx} value={val}>
          <StyledSelect>
          <span className="truncate-option">{val}</span>
          </StyledSelect>
        </MenuItem>
      ));
    }
  };
  return (
    <StyledSelect>
      <StyledInputLabel>
        {label}
        {required && <span className="required"> * </span>}
      </StyledInputLabel>
      <Select
        labelId="simple-selectlabel"
        id={id}
        disabled={disabled}
        autoComplete={false}
        displayEmpty
        fullWidth
        value={value}
        onChange={onChange}
        IconComponent={KeyboardArrowDownIcon}
        error={error}
        onBlur={onBlur}
        MenuProps={{
          PaperProps: {
            style: {
              maxHeight: 300,
              width: 'auto'
            }
          },
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'left',
          },
          transformOrigin: {
            vertical: 'top',
            horizontal: 'left',
          },
          getContentAnchorEl: null
        }}
        renderValue={(selected) => {
          if (selected?.length) {
            return <span className="truncate-text">{selected}</span>;
          }
          return <span className="placeholder">{placeholder}</span>;
        }}
      >
        {renderOptions()}
      </Select>
      <StyledHelperText>{helperText}</StyledHelperText>
    </StyledSelect>
  );
}

export default SelectField;
